import { ContractApplicationModel, DetailTotalData } from "src/api/contract/contract-types";
import ContractorInfoDetail from "./detailComponent/ContractorInfoDetail";
import ContractorInfoEdit from "./editComponent/ContractorInfoEdit";

/**
 * 계약자 정보 컴포넌트의 props 인터페이스
 */
type Props = {
  detailData: DetailTotalData; // 상품 상세 조회 정보
  detailFlag: boolean; // 상세 정보 표시 여부
  saveData?: any; // 저장 데이터
  setSaveData?: any; // 저장 데이터 업데이트 함수
  contractApplication?: ContractApplicationModel | null; // 계약 이용신청서 정보
  getContractApplication?: () => Promise<void>; // 계약 이용신청서 정보 조회 함수
};

const ContractorInfo = ({ detailData, detailFlag, saveData, setSaveData, contractApplication, getContractApplication }: Props) => {
  if (detailFlag) {
    return (
      <ContractorInfoDetail detailData={detailData!} contractApplication={contractApplication} getContractApplication={getContractApplication} />
    );
  } else {
    return <ContractorInfoEdit saveData={saveData} setSaveData={setSaveData} />;
  }
};

export default ContractorInfo;
